<frontend-dropdown-plain
  elementId="add-edit-announcement-icon"
  noItemsText="Start typing address..."
  [placeholder]="placeholder || ''"
  [items]="places"
  [clearable]="true"
  [disableFiltering]="true"
  [maxSelectedItems]="1"
  [class.no-touch]="disabled"
  [(ngModel)]="value"
  (searchTermChange)="searchTermChanged($event)"
  (ngModelChange)="change($event); placeResult($event)"
  (popoverClose)="onClickOutside()"
></frontend-dropdown-plain>
